import {ValueAndLabelModel} from '../../../common/model/valueAndLabel.model';

export class JwtProviderModel {
    accountBusinessCode: string;
    providerBusinessCode: string;
    name: string;
    services: ValueAndLabelModel[] = [];
}
